import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { ISmartSendContext } from '../context/SmartSendContextModels';

export function GetSelectedItems(
  filterKey,
  state: ISmartSendContext,
  smartSendItemsCache: SmartSendItemApiModel[]
): SmartSendItemApiModel[] {
  if (!filterKey) {
    return smartSendItemsCache.filter((i) => i.State?.selected);
  }
  return smartSendItemsCache.filter((i) => state.filters[filterKey].summary.selected.includes(i.Id));
}
